import React from 'react';
import {Button, Icon, Modal, Upload} from "antd";
import {injectIntl} from "react-intl";

import './UploadPictures.css'
import Api from "../../../services/Api";
import FieldError from "../input/FieldError";

class UploadPictures extends React.Component {

  constructor(props){
    super(props);
    this.cleanUrl(this.props.files)
    this.state = {
      previewVisible:false,
      previewImage: '',

    }
  }

  cleanUrl = (files) => {
    if (!files){
      return;
    }
    // we don't need URLS, we will fetch images using ajax so that we can send the authoriation header along
    files.map(file=>{
      if (file.url && !file.url.startsWith("data:")){
        delete file.url;
      }
    })
  }

  componentWillReceiveProps = async (nextProps) => {
    this.cleanUrl(nextProps.files)
    if (nextProps.files){
      nextProps.files.forEach(async file=>{
        if (!file.url) {
          const previous = this.props.files && this.props.files.find(prev => prev.uid === file.uid);
          if (previous) {
            file.url = previous.url;
          } else if (!file.originFileObj){
            try {
              const blob = await Api.get(`/file`, {key: file.uid});
              let result = await this.readFileAsync(blob);
              file.url = result;
            } catch (error){
              console.log('Could not load file', file.uid);
            }
          }
        }
      })
    }
  }

  readFileAsync = (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    })
  }

  componentDidMount = async () =>{

    const {files=[]} = this.props;
    if (files){
      for (let index = 0;index < files.length;index++){
        const f = files[index];
      //let promises = files.map(async f => {
        try {
          const blob = await Api.get(`/file`, {key: f.uid});
          let result = await this.readFileAsync(blob);
          files[index] = {
            uid: f.uid,
            url: result,
          };
        } catch (error){
          console.log('Could not load file', f.uid);
        }
      }
      this.forceUpdate();
    }

  }

  handleCancel = () => this.setState({ previewVisible: false });


  handlePreview = (file) =>{
    if (!file.preview) {
      file.preview = file.url;
      let that = this;
      Api.get(`/file`, {key:file.uid}).then(blob=>{
          const reader = new FileReader();
          reader.onload = function () {
            file.preview = reader.result;
            that.setState({
              previewVisible: true,
              previewImage: file.preview,
            });
          };
          reader.readAsDataURL(blob);
        }
      ).catch(error=>console.log('Could not fetch file', error));
    } else {
      this.setState({
        previewVisible: true,
        previewImage: file.preview,
      });
    }

  }
  render() {
    const {intl:{formatMessage}, allowUpload, files = [], error, listType, ...attributes} = this.props;
    files.forEach(f => f.uid = f.uid || f.key);

    const { previewVisible, previewImage } = this.state;


    const uploadButton = listType === 'text' ? <Button><Icon type="upload" />{formatMessage({id: 'action.upload'})}</Button>
      : <div>
          <Icon type="plus"/>
          <div className="ant-upload-text">{formatMessage({id: 'action.upload'})}</div>
        </div>;

    return (
      <div>
          <div className="upload-list">
            <Upload {...attributes} fileList={files} listType={listType || 'picture-card'} onPreview={this.handlePreview}>
              {allowUpload && uploadButton}
            </Upload>
          </div>

          {error && (
            <FieldError error={error}/>
          )}

          <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
            <br/>
            <img style={{ width: '100%' }} src={previewImage} />
          </Modal>
      </div>


    )
  }
}

export default injectIntl(UploadPictures);



// WEBPACK FOOTER //
// ./src/components/common/upload/UploadPictures.js